@if ((appService.loading$ | async) === false) {
  <div class="skip-link-wrapper">
    <a matButton="elevated" [href]="appService.currentUrl+'#maincontent'"
      [attr.inert]="(appService.pageLoading$ | async) || (appService.loading$ | async)
        ? '' : null">Skip to Main Content</a>
  </div>
}

<div class="app-container" [attr.aria-busy]="(appService.loading$ | async) ? 'true' : 'false'"
  [ngClass]="{
    'app-container--rail': appService.railPage
  }"
  [attr.inert]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? '' : null">
  <app-header [helpOpened]="helpSidenav?.opened" (toggleHelp)="toggleHelp()"></app-header>
  <!-- Container for rail navigation and help sidebar -->
  <mat-sidenav-container class="inner-container">
    <!-- Rail navigation -->
    @if (railNavigationService.enabled()) {
      <mat-sidenav #sideNav
        class="mat-sidenav--rail"
        fixedInViewport
        role="navigation"
        mode="side"
        disableClose
        [fixedTopGap]="64"
        [opened]="true">
        <app-rail-navigation></app-rail-navigation>
      </mat-sidenav>
    } <!-- End rail navigation -->

    <!-- Main application content -->
    <mat-sidenav-content class="main-layout">
      @if (notificationBannerService.enabled) {
        <teller-online-notification-banner
          [ngClass]="notificationBannerService.banners[0]?.bannerClass"
          [message]="notificationBannerService.banners[0]?.message"
          [dismissAction]="notificationBannerService.banners[0]?.dismissAction"
          [resolveAction]="notificationBannerService.banners[0]?.resolveAction"
          [icon]="notificationBannerService.banners[0]?.icon"
          [iconColor]="notificationBannerService.banners[0]?.iconColor"
          [tag]="notificationBannerService.banners[0]?.tag">
        </teller-online-notification-banner>
      }

      <!-- tabindex="-1" makes this a programmatic focus target: the skip link lands here, and
           RestrictFocusDirective hands focus back here when a drawer closes on a route that
           renders no #main-content-focus of its own. -->
      <main id="maincontent" tabindex="-1" [ngClass]="{'debug': appService.debug}">
        @if ((appService.loading$ | async) === false &&
          (authService.showLoginPrompt$ | async) === false) {
          <router-outlet></router-outlet>
        }
        <article class="skeleton-content" aria-hidden="true"></article>
      </main>
    </mat-sidenav-content> <!-- End main application content -->

    <!-- Help sidebar — always a modal side sheet (scrim + focus trap), matching the public
    portal's help drawer and the pre-strip admin's own modal treatment. A prior desktop-only
    "side" mode (docked, no scrim, content shifts beside it) had no width enforcement — Material's
    --mat-sidenav-container-width defaults to `auto`, which side mode's block layout stretches
    to fill the viewport instead of the intended 360px, so it spanned the whole page. -->
    <mat-sidenav #helpSidenav
      id="help-sidebar"
      class="mat-sidenav--help"
      [appRestrictFocus]="helpSidenav.opened"
      fixedInViewport
      position="end"
      fixedTopGap="0"
      role="region"
      mode="over">
      <teller-online-help-sidebar
        [showViewAllLink]="true"
        [viewAllRoute]="'/config/help'"
        (toggleHelp)="toggleHelp()">
      </teller-online-help-sidebar>
    </mat-sidenav> <!-- End help sidebar -->
  </mat-sidenav-container> <!-- End rail navigation container -->
</div>

<teller-online-load-panel></teller-online-load-panel>
<teller-online-engagement-host />
